import { render, staticRenderFns } from "./ActiveSchoolsReport.vue?vue&type=template&id=803f12ce&scoped=true&"
import script from "./ActiveSchoolsReport.vue?vue&type=script&lang=js&"
export * from "./ActiveSchoolsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803f12ce",
  null
  
)

export default component.exports